import { sendGTMEvent } from '@next/third-parties/google'
import { ProductStoreFields } from '@/hooks/use-cart-product/selectors'
import { Customer } from '@/hooks/use-customer/store'
import { AddressParam } from '@/actions/stripe'

export type EventItem = {
  item_id: string
  item_name: string
  affiliation?: string
  coupon?: string
  creative_name?: string
  creative_slot?: string
  discount?: number
  index?: number
  item_brand?: string
  item_category?: string
  item_category2?: string
  item_category3?: string
  item_category4?: string
  item_category5?: string
  item_list_name?: string
  item_list_id?: string
  item_variant?: string
  location_id?: string
  price?: number
  quantity?: number
  promotion_id?: string
  promotion_name?: string
}

export type eventItems = Array<EventItem>

export type CommonEvent = {
  email?: string
  academy?: string
  full_name?: string
  phone?: string
  city?: string
  country?: string
  postal_code?: string
}

export type PurchaseEvent = {
  transaction_id: string
  value: number
  currency: string
  tax?: number
  shipping?: number
  coupon?: string
  items: eventItems
}

export type ECommerceEvent = {
  currency: string
  value: number
  coupon?: string
  items: eventItems
}

export function sendGAEvent(
  eventType: 'purchase' | 'begin_checkout' | 'add_payment_info' | 'add_to_cart',
  product: ProductStoreFields,
  academy: string,
  customer: Customer,
  address: AddressParam
) {
  try {
    const prodSelected = product?.currentProducts

    const extraParams: CommonEvent = {}
    mapParamsToEvent(extraParams, customer, address)
    if (academy) {
      extraParams.academy = academy
    }

    let eCommerceEvent: (ECommerceEvent | PurchaseEvent) & CommonEvent = {
      currency: 'EUR',
      value: product.totalAmountWithDiscount,
      coupon: product.promotion?.code || '',
      items: prodSelected.productsList.map((item) => ({
        item_id: item.priceId,
        item_name: item.title,
        item_category: item.academy,
        item_category2: item.period,
        price: item.amount,
        quantity: 1,
      })),
      ...extraParams,
    }

    if (eventType === 'purchase') {
      eCommerceEvent = {
        ...eCommerceEvent,
        transaction_id: new Date().getTime().toString(),
      }
    }

    clearEcommerce()
    sendGTMEvent({ event: eventType, ecommerce: eCommerceEvent })
  } catch (e) {
    console.error('cannot send GA event:')
    console.error(e)
  }
}

function clearEcommerce() {
  sendGTMEvent({ ecommerce: null })
}
function mapParamsToEvent(
  extraParams: CommonEvent,
  customer: Customer,
  address: AddressParam
) {
  if (customer?.email) {
    extraParams.email = customer.email
  }
  if (customer?.name) {
    extraParams.full_name = `${customer.name} ${customer.lastName}`
  }
  if (customer?.phone) {
    extraParams.phone = customer.phone
  }
  if (address?.city) {
    extraParams.city = address.city
  }
  if (address?.country) {
    extraParams.country = address.country
  }
  if (address?.postal_code) {
    extraParams.postal_code = address.postal_code
  }
}
